import React, { Component } from 'react';
import '../../../resources/AdminStandardPage.css';
import AttachmentField from '../../../components/AttachmentField/AttachmentField';
import AuthenticationService from '../../../services/AuthenticationService';
import DeletePUGCertificates from '../../../components/Dialogs/DeleteDialog/DeleteDialog';
import ReactPaginate from 'react-paginate';
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import { nonrefundableFundsService } from '../../../services/NonrefundableFundsService';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import { getArchiveYears } from '../../../services/ArchiveYearsService';

class AdminNonrefundableFonds extends Component {
  constructor(props) {
    super(props);
    const archiveYears = getArchiveYears();

    this.state = {
      disabledDocument: false,
      newSituation: {
        title: '',
        document: '',
        date: ''
      },
      existingSituations: [],
      searchFund: {
        title: '',
        archiveYear:
          archiveYears && archiveYears.length > 0
            ? archiveYears[0].value
            : new Date().getFullYear().toString()
      },
      archiveYears,
      deleteSituation: {
        openedDialog: false,
        deleteId: 0
      },
      pagination: {}
    };

    this.authentication = new AuthenticationService();
  }
  componentWillMount() {
    this.search();
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  setSituationState = response => {
    let existingSituations = this.state.existingSituations;
    existingSituations = response.annual_funds_programs;
    this.setState({
      existingSituations
    });
    let pagination = { ...this.state.pagination };
    pagination = response.pagination;
    this.setState({
      pagination
    });
  };
  handlePageClick = currentPage => {
    this.search(currentPage.selected + 1);
  };
  updateField = event => {
    const field = event.target.name;
    let newSituation = { ...this.state.newSituation };
    newSituation[field] = event.target.value;
    this.setState({
      newSituation
    });
  };
  updateSearchField = event => {
    const field = event.target.name;
    const searchFund = { ...this.state.searchFund };
    searchFund[field] = event.target.value;
    this.setState(
      {
        searchFund
      },
      () => {
        if (field === 'archiveYear') {
          this.search();
        }
      }
    );
  };
  search = (pageNumber = 1) => {
    nonrefundableFundsService
      .search(this.state.searchFund, pageNumber)
      .then(response => {
        this.setSituationState(response);
      })
      .catch(error => console.log(error));
  };
  resetForm = () => {
    let newSituation = { ...this.state.newSituation };
    newSituation = {
      title: '',
      document: ''
    };
    this.setState({ newSituation });
    this.setState({ disabledDocument: false });
  };
  openDeleteDialog = id => {
    let deleteSituation = { ...this.state.deleteSituation };
    deleteSituation = {
      openedDialog: true,
      deleteId: id
    };

    this.setState({ deleteSituation });
  };

  closeDeleteDialog = () => {
    let deleteSituation = { ...this.state.deleteSituation };
    deleteSituation = {
      openedDialog: false,
      deleteId: 0
    };

    this.setState({ deleteSituation });
  };
  handleFormSubmit = event => {
    event.preventDefault();

    nonrefundableFundsService
      .createOrUpdate(this.state.newSituation)
      .then(response => {
        this.resetForm();
        this.search();

        this._notificationSystem.addNotification({
          message: `Situatia a fost ${
            this.state.newSituation.id ? 'editata' : 'adaugata'
          } cu success.`,
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema la adaugare, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };
  onDropDocument = documents => {
    let newSituation = { ...this.state.newSituation };
    let reader = new FileReader();
    let self = this;

    reader.onload = function(upload) {
      newSituation.document = documents[0];

      self.setState({ newSituation });
      self.setState({ disabledDocument: true });
    };
    reader.readAsDataURL(documents[0]);
  };

  removeDocument = () => {
    let newSituation = { ...this.state.newSituation };
    newSituation.document = null;

    this.setState({ newSituation });
    this.setState({ disabledDocument: false });
  };

  setSituationForEdit = situation => {
    let newSituation = { ...this.state.newSituation };
    newSituation = Object.assign({}, situation);
    this.setState({ newSituation });

    if (newSituation.document && newSituation.document.url) {
      this.setState({ disabledDocument: true });
    }
  };

  handleDelete = () => {
    nonrefundableFundsService
      .deleteSituation(this.state.deleteSituation.deleteId)
      .then(() => {
        this.closeDeleteDialog();
        this.search();

        this._notificationSystem.addNotification({
          message: 'Situatia a fost stearsa cu success.',
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema la stergere, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  render() {
    return (
      <div className="admin-standard-page">
        <div className="admin-standard-page__title">
          <h3 className="admin-page__profile-title profile-title-specific">
            Buget
          </h3>
          <h1 className="admin-switch-title default-title">
            Situația anuală a finanțărilor nerambursabile acordate persoanelor
            cu scop nepatrimonial
          </h1>
        </div>
        <div className="title-line" />
        <div className="admin-standard-page__content">
          <div className="admin-standard-page__create-project">
            <div className="card">
              <form className="admin-form" onSubmit={this.handleFormSubmit}>
                <h2 className="admin-form__title">Adaugă o situatie:</h2>
                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Titlu document*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="text"
                    name="title"
                    onChange={this.updateField}
                    value={this.state.newSituation.title}
                  />
                  <h4 className="label-title label-title-provisions">
                    Dată document*
                  </h4>
                  <input
                    className="general-field date-field"
                    type="date"
                    name="date"
                    onChange={this.updateField}
                    value={this.state.newSituation.date}
                  />
                </div>

                <div className="admin-form__upload">
                  <h4 className="label-title label-title-provisions">
                    Document:
                  </h4>
                  <AttachmentField
                    onDrop={this.onDropDocument}
                    removeDocument={this.removeDocument}
                    disabledDocuments={this.state.disabledDocument}
                    document={this.state.newSituation.document}
                    documentFilename={this.state.newSituation.document_filename}
                    type="application/pdf"
                  />
                </div>
                <div className="form-buttons">
                  <div className="admin-form__submit">
                    <button
                      type="submit"
                      className="submit-button general-button"
                    >
                      {this.state.newSituation.id
                        ? 'Editează Document'
                        : 'Adaugă Document'}
                    </button>
                  </div>
                  {Object.values(this.state.newSituation) && (
                    <button
                      type="button"
                      className="general-button reset-button"
                      onClick={() => this.resetForm()}
                    >
                      Resetează câmpurile
                    </button>
                  )}
                </div>
              </form>
              <div className="admin-form__field admin-year-filter admin-year-filter--documents">
                <h4 className="label-title label-title-provisions">
                  Afiseaza documente pentru anul:
                </h4>
                <FormControl className="admin-year-filter__control">
                  <NativeSelect
                    className="admin-year-filter__select"
                    value={this.state.searchFund.archiveYear}
                    onChange={this.updateSearchField}
                    inputProps={{
                      name: 'archiveYear'
                    }}
                  >
                    {this.state.archiveYears.map(archive => (
                      <option value={archive.value}>{archive.name}</option>
                    ))}
                  </NativeSelect>
                </FormControl>
              </div>
            </div>
          </div>
          {this.state.existingSituations &&
            this.state.existingSituations.length > 0 && (
              <div className="admin-standard-page__existing-items">
                <div className="card">
                  <div className="existing-items">
                    <h2 className="existing-items__title label-title">
                      Raspunsuri existente
                    </h2>
                    <div className="existing-items__content">
                      {this.state.existingSituations.map(response => (
                        <div
                          className="existing-items__content-card"
                          key={response.id}
                        >
                          <div className="card-content provisions-title-content">
                            <h3 className="major-provisions-title">
                              {response.title}
                            </h3>
                          </div>
                          <div className="existing-items__actions-card">
                            <div
                              className="provisions-title-content"
                              onClick={() => this.setSituationForEdit(response)}
                            >
                              <h4 className="action-title"> Editează</h4>
                            </div>

                            <div
                              className="provisions-title-content"
                              onClick={() => this.openDeleteDialog(response.id)}
                            >
                              <h4 className="action-title delete-button">
                                {' '}
                                Șterge
                              </h4>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <DeletePUGCertificates
                      opened={this.state.deleteSituation.openedDialog}
                      handleClose={this.closeDeleteDialog}
                      handleDelete={this.handleDelete}
                      headline="Sunteti sigur ca doriti sa stergeti acest document?"
                      aditionalText="Dupa stergere, acest document nu va mai putea fi recuperata."
                    />
                  </div>
                  {this.state.pagination.last_page > 1 && (
                    <ReactPaginate
                      previousLabel={'<'}
                      nextLabel={'>'}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      pageCount={this.state.pagination.last_page}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={this.handlePageClick}
                      containerClassName={'pagination'}
                      subContainerClassName={'pages pagination'}
                      activeClassName={'active'}
                    />
                  )}
                </div>
              </div>
            )}
        </div>
        <NotificationSystem
          ref="notificationSystem"
          style={NotificationSystemStyle}
        />
      </div>
    );
  }
}
export default AdminNonrefundableFonds;
